import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withModifiers as _withModifiers, isRef as _isRef, withKeys as _withKeys, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-602021b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title" }
const _hoisted_2 = { class: "reissueText" }
const _hoisted_3 = { class: "reissueForm" }
const _hoisted_4 = ["onSubmit"]

import DialogBase from '@/components/molecules/DialogBase'
import InputField from '@/components/atoms/InputField'
import http from '@/js/utils/http.js'
import API from '@/js/const/api'
import { computed, nextTick, ref, watch, withDefaults } from 'vue'
import { ElMessage } from 'element-plus'

type PropsType = {
  modelValue?: boolean
  loginEmail?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PasswordReissueDialog',
  props: {
    modelValue: { type: Boolean, default: false },
    loginEmail: { default: '' }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:modelValue', value: boolean): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { modelValue: boolean, loginEmail: string };



const loading = ref<boolean>(false)
const email = ref<string>('')
const setFocusState = ref<boolean>(false)
const isValidEmail = ref<boolean>(true)



const internalValue = computed({
  get: () => props.modelValue,
  set: (newVal) => {
    emit('update:modelValue', newVal)
  },
})

const reissueButtonDisabled = computed<boolean>(
  () => loading.value || !email.value || !isValidEmail.value
)

const passwordReissue = () => {
  if (loading.value || !email.value || !isValidEmail.value) {
    return
  }
  loading.value = true
  const params = {
    email: email.value,
    return_url: location.origin + '/password_reissue',
  }
  http
    .post(API.PASSWORD_REQUEST_RESET, params)
    .then(() => {
      loading.value = false
      email.value = ''
      internalValue.value = false
      ElMessage({
        message: 'パスワード再設定用ページのURLを送信しました。メールをご確認ください。',
        type: 'success',
      })
    })
    .catch(() => {
      loading.value = false
      ElMessage({
        message:
          'パスワード再設定URLの送信に失敗しました。入力したメールアドレスが正しいかどうか確認してください。',
        type: 'error',
      })
    })
}

const emailInit = () => {
  email.value = ''
}

watch(
  () => props.modelValue,
  (value) => {
    if (value) {
      email.value = props.loginEmail
      nextTick(() => {
        setFocusState.value = true
      })
    } else {
      setFocusState.value = false
      isValidEmail.value = true
    }
  }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DialogBase), {
    modelValue: _unref(internalValue),
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(internalValue) ? (internalValue).value = $event : null)),
    loading: loading.value,
    "ok-btn-disabled": _unref(reissueButtonDisabled),
    onApprove: passwordReissue,
    onKeyup: _withKeys(passwordReissue, ["enter"]),
    onClose: emailInit
  }, {
    title: _withCtx(() => [
      _createElementVNode("h1", _hoisted_1, _toDisplayString(_ctx.$t('password_reissue_dialog.change_password')), 1)
    ]),
    body: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t('password_reissue_dialog.reissue_text')), 1),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("form", {
            action: "#",
            onSubmit: _withModifiers(passwordReissue, ["prevent"]),
            autocomplete: "off"
          }, [
            _createVNode(_unref(InputField), {
              modelValue: email.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
              "is-valid": isValidEmail.value,
              "onUpdate:is-valid": _cache[1] || (_cache[1] = ($event: any) => ((isValidEmail).value = $event)),
              type: "text",
              name: "linkEmail",
              "name-as": _ctx.$t('validation.email'),
              placeholder: _ctx.$t('validation.email'),
              rule: "required|email",
              "set-focus-state": setFocusState.value
            }, null, 8, ["modelValue", "is-valid", "name-as", "placeholder", "set-focus-state"])
          ], 40, _hoisted_4)
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "loading", "ok-btn-disabled", "onKeyup"]))
}
}

})